var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inheritable-value",
    class: {
      'inheritable-value--inherited': _vm.isInherited
    }
  }, [(_vm.isBlank) ? _vm._t("empty", [_c('text-placeholder')]) : _vm._t("value", [(_vm.isInherited) ? _vm._t("inherited", [_vm._v(_vm._s(_vm.inheritedValue))]) : _vm._t("overridden", [(_vm.isDate) ? _vm._t("default", [_vm._v("\n        " + _vm._s(_vm.valueAsDate) + "\n      ")]) : _vm._t("default", [_vm._v("\n        " + _vm._s(_vm.value) + "\n      ")])])], {
    value: _vm.presentValue,
    inherited: _vm.isInherited
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e96fb6d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/InheritableValue.vue
// module id = 2131
// module chunks = 0